<template>
  <div class="documents">
    <!-- <b-row v-if="add" cols="6" class="text--right">
                <b-button @click="addDoc = true" color="primary" >Ajouter</b-button>
            </b-row> -->
    <b-row v-if="documents.length == 0" class="p-15">
      Vous n'avez pas déposé de pièce pour le moment
    </b-row>
    <b-row v-if="documents.length > 0 && card == false">
      <span class="text-left info-title">Documents</span>
      <!-- <pre>{{ tabDocs }}</pre> -->
      <div class="table-documents">
        <!-- TODO faire 2 b-row pour l'utilisateur et pour le reste, l'utilisateur ne doit pas voir Arrêté de décision && Arrêté de décision SIGNÉ -->
        <div v-if="userConnected">
          <template v-for="category in Object.keys(tabDocs)">
            <b-row class="head-table-documents" :key="category">
              <b-col cols="5" sm="5" md="5" lg="5" class="col-libelle">
                <span>{{ category }}</span>
              </b-col>
            </b-row>
            <b-row class="under-head-table-documents">
              <b-col cols="5" sm="5" md="5" lg="5" class="text-left col-libelle"
                >Nom</b-col
              >
              <b-col
                v-if="showLibelle"
                cols="5"
                sm="5"
                md="5"
                lg="5"
                class="text-left col-libelle"
                >Libellé</b-col
              >
              <b-col
                cols="2"
                sm="2"
                md="2"
                lg="2"
                class="text-right col-actions"
                >Actions</b-col
              >
            </b-row>
            <!-- <pre>{{ tabDocs[category] }}</pre> -->
            <b-row
              v-for="doc in tabDocs[category]"
              :key="doc.name"
              class="liste-documents"
            >
              <!-- <template> -->
              <b-col cols="5" sm="5" md="5" lg="5" class="col-libelle">
                <span :id="'name-doc-' + doc.id">{{ doc.name }}</span>
              </b-col>
              <b-col v-if="showLibelle" cols="5" sm="5" md="5" lg="5">
                <span class="truncat">{{ doc.typeDocument.name }}</span>
              </b-col>
              <b-col
                cols="2"
                sm="2"
                md="2"
                lg="2"
                class="col-actions text-right"
              >
                <img
                  style="display: none"
                  :src="doc.url"
                  :class="'images' + doc.id"
                  v-viewer.rebuild="{ scalable: false, movable: true }"
                  v-if="imageMimeType.includes(doc.mimeType)"
                />

                <b-tooltip :target="'open-document-' + doc.id" triggers="hover">
                  <span>Ouvrir</span>
                </b-tooltip>
                <span :id="'open-document-' + doc.id">
                  <font-awesome-icon
                    icon="eye"
                    @click="open(doc)"
                    class="pointer"
                  />
                </span>

                <b-tooltip
                  :target="'download-document-' + doc.id"
                  triggers="hover"
                >
                  <span>Télécharger</span>
                </b-tooltip>
                <span :id="'download-document-' + doc.id">
                  <font-awesome-icon
                    icon="download"
                    class="ml-3 pointer"
                    @click="download(doc.url, 'Demande ' + requestid + ' - ' + doc.typeDocument.name + ' - ' + doc.name)"
                    @click.stop
                  />
                </span>

                <b-tooltip
                  v-if="remove"
                  :target="'remove-document-' + doc.id"
                  triggers="hover"
                >
                  <span>Supprimer</span>
                </b-tooltip>
                <span v-if="remove" :id="'remove-document-' + doc.id">
                  <font-awesome-icon
                    icon="trash"
                    class="ml-3 pointer"
                    @click="removeDoc(doc)"
                    @click.stop
                  />
                </span>
              </b-col>
              <!-- </template> -->
            </b-row>
          </template>
        </div>
      </div>
    </b-row>
    <!-- DIALOG MODALS -->
    <b-modal
      title="Visualisation du PDF"
      hide-footer
      size="xl"
      header-bg-variant="warning"
      header-text-variant="white"
      v-model="viewerPdf"
    >
      <vue-pdf-preview
        style="width: 100%"
        ref="myPdfComponent"
        :src="pdfToView"
        v-for="i in numPages"
        :key="i"
        :page="i"
      ></vue-pdf-preview>
    </b-modal>
    <b-modal
      title="Visualisation du Document"
      hide-footer
      size="xl"
      header-bg-variant="warning"
      header-text-variant="white"
      v-model="viewerDoc"
    >
      <b-card>
        <vue-doc-preview :value="docToView" type="office" />
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import Vuex from "vuex";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import VuePdfPreview from "vue-pdf";
import VueDocPreview from "vue-doc-preview";

Vue.use(Viewer);
export default {
  components: {
    "vue-doc-preview": VueDocPreview,
    "vue-pdf-preview": VuePdfPreview,
  },
  computed: {
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
    ...Vuex.mapGetters("Dossiers", ["dossierSelected"]),
    tabDocs() {
      let tab = {};
      let me = this;
      this.documents.forEach((document) => {
        let nature = document.typeDocument.categorie;
        switch (document.typeDocument.id) {
          case 93:
          case 106:
          case 108:
            //documents cachés
            break;
          case 97:
            if (
              [1, 2, 3].includes(me.dossierSelected.state.id) &&
              me.userConnected &&
              !me.userConnected.roles.includes("ROLE_INSTRUCTEUR") &&
              !me.userConnected.roles.includes("ROLE_ADMIN")
            ) {
              // on cache les annexes d'arrêté si l'arrêté n'est pas rendu.
              break;
            }
          default:
            Object.keys(tab).includes(nature)
              ? tab[nature].push(document)
              : (tab[nature] = [document]);
            break;
        }
      });
      return tab;
    },
  },
  data: () => ({
    docToRefuse: null,
    docToReplace: null,
    uploadProgress: false,
    error: null,
    errorMessage: null,
    doc: null,
    typeDocument: null,
    addDoc: false,
    ColCard: null,
    pdfToView: "",
    viewerPdf: false,
    viewerDoc: false,
    numPages: 1,
    dialogRefuse: false,
    docToView: "",
    ImgDoc: require("../assets/document.png"),
    ImgPdf: require("../assets/pdf.png"),
    imageMimeType: ["image/png", "image/png", "image/gif", "image/jpeg"],
    pdfMimeType: ["application/pdf"],
    DocMimeType: [
      "application/octet-stream",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "pplication/vnd.oasis.opendocument.text",
      "application/vnd.ms-powerpoint",
      "text/csv",
      "application/vnd.ms-office",
      "text/plain",
      "application/vnd.oasis.opendocument.spreadsheet",
      "application/vnd.oasis.opendocument.presentation",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ],
  }),
  methods: {
    replaceDoc(doc) {
      this.docToReplace = doc;
      this.addDoc = true;
    },
    open(doc) {
      if (this.imageMimeType.includes(doc.mimeType)) {
        const viewer = this.$el.querySelector(".images" + doc.id).$viewer;
        viewer.show();
      } else if (this.pdfMimeType.includes(doc.mimeType)) {
        this.pdfToView = VuePdfPreview.createLoadingTask(doc.url);
        this.pdfToView.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        });
        this.viewerPdf = true;
      } else if (this.DocMimeType.includes(doc.mimeType)) {
        const newWindow = window.open();
        if (!newWindow) {
          Vue.prototype.$awn.alert("Impossible d'ouvrir une nouvelle fenêtre.");
          return;
        }
        fetch(window.urlapi + "onlyoffice/" + doc.id + "?mode=view", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + window.$cookies.get("token-sudthd"),
          },
        })
          .then(async (response) => {
            if (!response.ok) {
              const text = await response.text();
              throw new Error("Erreur " + response.status + " : " + text);
            }
            return response.text();
          })
          .then((html) => {
            newWindow.document.open();
            newWindow.document.write(html);
            newWindow.document.close();
          })
          .catch((error) => {
            console.error("Erreur lors de l'ouverture du document :", error);
            newWindow.close();
            Vue.prototype.$awn.alert(
              "Erreur lors de l'ouverture du document : " + error.message,
              {
                position: "bottom-right",
                timeout: 5000,
              }
            );
          });
      }
    },
    removeDoc(doc) {
      this.$emit("removeDocument", doc);
    },
    forceFileDownload(response, name) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    download(doc, name) {
      axios({
        method: "get",
        url: doc,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, name);
          window.open(response.data.data);
        })
        .catch(() => console.log("error occured"));
    },
  },

  name: "documents",
  props: {
    /**
     * tableau des documents à passer en paramètre
     * sous form {url : '', name :'', libelle : '', valid : true}
     */
    documents: {
      type: Array,
      required: true,
      default: function() {
        return [];
      },
    },
    //card
    card: { type: Boolean, required: true, default: true },
    // taille
    xs: { type: String, required: false, default: "2" },
    md: { type: String, required: false, default: "2" },
    lg: { type: String, required: false, default: "2" },
    xl: { type: String, required: false, default: "2" },
    sm: { type: String, required: false, default: "2" },

    //si on add ou on remove
    remove: { type: Boolean, required: false, default: false },
    add: { type: Boolean, required: false, default: false },
    replace: { type: Boolean, required: false, default: false },
    //show le libelle
    showLibelle: { type: Boolean, required: false, default: true },

    //si prop valid
    showValid: { type: Boolean, required: false, default: false },
    requestid: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
};
</script>
